import * as React from 'react'
import { SVGProps } from 'react'

function ThreePeople(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? 32}
      height={props.height ?? 32}
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <defs>
        <rect width={props.width ?? 32} height={props.height ?? 32} fill="none" />
        <path fill="#fff" d="M0 0h32v32H0z" />
      </defs>
      <g
        stroke={props.color ?? '#1D59AF'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M24 15a7.488 7.488 0 0 1 6 3M2 18a7.49 7.49 0 0 1 6-3M16 23a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" />
        <path d="M9 27a8.125 8.125 0 0 1 14 0M20.125 10A4 4 0 1 1 24 15M8 15a4 4 0 1 1 3.875-5" />
      </g>
    </svg>
  )
}

export default ThreePeople
